import { GUIDE_NAME, WA_NUMBER, WA_MESSAGES } from '../constants'
import SectionLabel from './SectionLabel'

export default function GuideBar() {
  return (
    <section className="section bg-stone">
      <div className="guide-grid" style={{
        display: 'grid', gridTemplateColumns: 'minmax(0,1fr) 320px', gap: '48px', alignItems: 'center',
      }}>
        <div>
          <SectionLabel>Meet Your Guide</SectionLabel>
          <h2 className="section-title">Follow the guide.</h2>
          <p className="section-sub" style={{ marginBottom: '24px' }}>
            Every trek is led personally by a licensed, on-the-ground expert — not a call center.
            You plan your route directly with the person who walks it.
          </p>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <span className="badge badge-green">Licensed Guide</span>
          </div>
        </div>

        <div style={{
          background: 'var(--white)', border: '1px solid var(--stone-mid)', borderRadius: 'var(--radius-lg)',
          padding: '28px', textAlign: 'center',
        }}>
          <div style={{
            width: '72px', height: '72px', borderRadius: '50%', background: 'var(--green)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px',
            color: 'white', fontWeight: 600, fontSize: '28px', fontFamily: 'var(--serif)',
          }}>
            {GUIDE_NAME.charAt(0)}
          </div>
          <div style={{ fontSize: '11px', color: 'var(--green)', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '4px' }}>
            Expert Guide
          </div>
          <div style={{ fontSize: '18px', fontWeight: 600, fontFamily: 'var(--serif)', marginBottom: '16px' }}>
            {GUIDE_NAME}
          </div>
          <a
            href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGES.general)}`}
            target="_blank" rel="noreferrer"
            className="btn btn-green btn-sm"
            style={{ width: '100%', justifyContent: 'center' }}
          >
            Message {GUIDE_NAME}
          </a>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .guide-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  )
}
